import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';

const ContentCourseRepeatRateGauge = (props) => (
  <KpiChart
    title="Audio listening difficulty"
    description="The number represents the average repeat button usage per item execution. The exercises which represent this number are: Single Choice Text, Single Choice Audio, Single Choice Image, Dictation, Presentation, Short Video, Pronunciation, True or False, Speech Practice, Long Video, Long Audio, Multiple Choice Text, Vocabulary, Vocabulary Kids and Meanings Associating."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[0, 2, 3, 5]}
    stepSize={1}
    reverseColors={true}
    onClickHistory={props.onClickHistory}
    formatter={props.formatter}
  />
);

ContentCourseRepeatRateGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  onClickHistory: PropTypes.func,
  formatter: PropTypes.func.isRequired,
};

export default ContentCourseRepeatRateGauge;
